var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 0.5H14.5C14.9641 0.5 15.4092 0.684375 15.7374 1.01256C16.0656 1.34075 16.25 1.78587 16.25 2.25V14.5C16.25 14.9641 16.0656 15.4092 15.7374 15.7374C15.4092 16.0656 14.9641 16.25 14.5 16.25H8.375M8.375 0.5H2.25C1.78587 0.5 1.34075 0.684375 1.01256 1.01256C0.684375 1.34075 0.5 1.78587 0.5 2.25V14.5C0.5 14.9641 0.684375 15.4092 1.01256 15.7374C1.34075 16.0656 1.78587 16.25 2.25 16.25H8.375M8.375 0.5V16.25",
    stroke: "#354D9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.300a8324726a34395c2196f5b3f09237.svg";
export { ForwardRef as ReactComponent };